import { Component, OnInit, Input } from "@angular/core";
import { MDBModalRef, MDBModalService } from "ng-uikit-pro-standard";
import { AddCityFormComponent } from "../../forms/add-city-form/add-city-form.component";
import { AddVenueFormComponent } from "../../forms/add-venue-form/add-venue-form.component";
import { FirebaseService } from "src/app/core/firebase/firebase.service";
import { AppService } from "src/app/core/app/app.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Component({
  selector: "ll-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"]
})
export class PageHeaderComponent implements OnInit {
  modalRef: MDBModalRef;

  constructor(
    private modalService: MDBModalService,
    public dialog: MatDialog,
    private app: AppService
  ) {}
  @Input() title: string;
  @Input() subtitle: string;
  @Input() button: string;
  ngOnInit() {}
  openCity() {
    this.app.state.onAddCityPressed();
    this.modalRef = this.modalService.show(AddCityFormComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
      containerClass: "",
      animated: true
    });
  }
  // openVenue() {
  //   this.modalRef = this.modalService.show(AddVenueFormComponent, {
  //     ignoreBackdropClick: false,
  //     class: "modal-dialog-centered",
  //     animated: true
  //   });
  // }
  openVenue() {
    const options = new MatDialogConfig();
    options.disableClose = false;
    options.autoFocus = true;
    options.width = "1200px";
    options.height = "600px";
    options.hasBackdrop = true;
    options.ariaLabel = "Add A Venue";
    const dialogRef = this.dialog.open(AddVenueFormComponent, options);
  }
}
